import React from 'react';

import { age } from 'common/utils';
import PropTypes from 'apps/age_verification/propTypes';
import { TranslatedMessage } from 'common/components/Intl';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from '../messages';

class WarrantyOnlyWarning extends React.Component {
  static propTypes = {
    minPurchaseAge: PropTypes.number.isRequired,
    dateOfBirth: PropTypes.string,
  };

  shouldShow() {
    if (!this.props.dateOfBirth) {
      return false;
    }

    const ageFromDob = age(this.props.dateOfBirth);
    return ageFromDob < this.props.minPurchaseAge;
  }

  render() {
    if (!this.shouldShow()) {
      return null;
    }

    return (
      <div className="WarrantyOnlyWarning">
        <div className="WarrantyOnlyWarning--title text flat-blue">
          <div className="WarrantyOnlyWarning--icon">⚠</div>
          <TranslatedMessage
            id={m.WARRANTY_ONLY_WARNING_TITLE}
            values={{ age: this.props.minPurchaseAge }}
          />
        </div>
        <p className="text--small navy">
          <TranslatedMessage id={m.WARRANTY_ONLY_WARNING_BODY} />
        </p>
      </div>
    );
  }
}

export default WarrantyOnlyWarning;
